import {
  ClockCircleOutlined,
  PlusOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { MIDDLE_STYLE } from '@constants/responsive';
import { fetchBookingSetting } from '@core/features/booking/thunks/fetchBookingSetting.thunk';
import { fetchReservations } from '@core/features/booking/thunks/fetchReservations.thunk';
import { BookingAppTabKey, useBookingAppTourStore } from '@core/hooks';
import { useAppBatchDispatch } from '@utils/thunk.util';
import { Button, Space, Tabs, TabsProps } from 'antd';
import React, { useEffect } from 'react';
import { BookingReservationTab, LoadableContainer } from '..';
import BookingSettingTab from '@components/BookingSettingTab';
import BookingDayTimelineTab from '@components/BookingDayTimelineTab';
import { useAppDispatch, useBookingState } from '@core/configureStore';
import { openModal } from '@core/features';
import SplashScreen from '@components/SplashScreen';

type Props = {};

const BookingManagementContent = (props: Props) => {
  const dispatch = useAppDispatch();
  const batchDispatch = useAppBatchDispatch();
  const { reservations: restaurantReservations, isLoading, bookingSetting } = useBookingState();
  const { selectedTabKey, setSelectedTabKey } = useBookingAppTourStore();

  const handleOnTabChanged = (key: string) => {
    setSelectedTabKey(key as any);
  };

  const handleAddNewReservation = () => {
    dispatch(
      openModal({
        modalName: 'addNewReservationModal',
      })
    );
  };

  useEffect(() => {
    const init = async () => {
      await batchDispatch([fetchReservations, fetchBookingSetting]);
    };
    init();
  }, []);

  const tabs: TabsProps['items'] = [
    {
      key: BookingAppTabKey.Timeline,
      label: (
        <div style={{ ...MIDDLE_STYLE }}>
          <ClockCircleOutlined style={{ marginRight: 10 }} /> Day View
        </div>
      ),
      children: <BookingDayTimelineTab />,
    },
    {
      key: BookingAppTabKey.Reservation,
      label: (
        <div style={{ ...MIDDLE_STYLE }}>
          <UserOutlined style={{ marginRight: 10 }} /> Reservation List (
          {restaurantReservations.length})
        </div>
      ),
      children: <BookingReservationTab />,
    },
    {
      key: BookingAppTabKey.Setting,
      label: (
        <div style={{ ...MIDDLE_STYLE }}>
          <SettingOutlined style={{ marginRight: 10 }} /> Setting
        </div>
      ),
      children: <BookingSettingTab />,
    },
  ];
  return (
    <LoadableContainer isLoading={!bookingSetting || isLoading} loadComponent={<SplashScreen />}>
      <div
        style={{
          padding: '20px 50px 50px 50px',
          position: 'relative',
        }}>
        <div style={{ ...MIDDLE_STYLE, justifyContent: 'space-between' }}>
          <h2>
            {
              {
                [BookingAppTabKey.Timeline]: 'Day View',
                [BookingAppTabKey.Reservation]: 'Reservations',
                [BookingAppTabKey.Setting]: 'Setting',
              }[selectedTabKey]
            }
          </h2>
          <Space>
            <Button type="primary" onClick={handleAddNewReservation}>
              <PlusOutlined /> Add new reservation{' '}
            </Button>
          </Space>
        </div>
        <Tabs
          defaultActiveKey={selectedTabKey}
          activeKey={selectedTabKey}
          items={tabs}
          onChange={handleOnTabChanged}
        />
      </div>
    </LoadableContainer>
  );
};

export default BookingManagementContent;
